import { useDispatch, useSelector } from 'react-redux';

import type { AppDispatch, RootState } from './store';

/** Typed `useDispatch` — use everywhere instead of the untyped react-redux hook. */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();

/** Typed `useSelector` — state is inferred as {@link RootState}. */
export const useAppSelector = useSelector.withTypes<RootState>();
